import { render, staticRenderFns } from "./CollectionCoverPhoto.vue?vue&type=template&id=7d162064&scoped=true&"
import script from "./CollectionCoverPhoto.vue?vue&type=script&lang=js&"
export * from "./CollectionCoverPhoto.vue?vue&type=script&lang=js&"
import style0 from "./CollectionCoverPhoto.vue?vue&type=style&index=0&id=7d162064&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d162064",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
